import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-6" }
const _hoisted_2 = { class: "text-lg font-bold text-neutral-900" }
const _hoisted_3 = { class: "text-sm text-gray-500" }


export default /*#__PURE__*/_defineComponent({
  __name: 'AuthTitle',
  props: {
    title: {
        type: String,
        default: null,
    },
    description: {
        type: String,
        default: null,
    },
},
  setup(__props) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(__props.title), 1),
    _createElementVNode("p", _hoisted_3, _toDisplayString(__props.description), 1)
  ]))
}
}

})